// ESM-Huelle fuer lib/scripts/components/CMP_CTable.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CTable (id)
{
    this.construct (id);

    this.name = "CTable";
    this.htmlType = "table";

    this.properties = 
    {
        styles: {}
    }
}

CTable.prototype = new CComponent;
export { CTable };
